import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import { Button } from './ui/button';

const ReadyToBuildSection = () => {
  return (
    <section id="ready-to-build" className="ready-to-build-section">
      <div className="ready-to-build-container">
        <div className="ready-to-build-content">
          <h3 className="ready-build-title">Ready to build adaptive intelligence?</h3>
          <p className="ready-build-description">
            Let's discuss how we can help your organization build adaptive capacity
            leading confident decisions with data-driven insights in this era of complex
            environments.
          </p>
          <div className="ready-build-buttons">
            <a 
              href="https://outlook.office.com/bookwithme/user/4526d5f0831940e5bde7b640ab309b68%40idoconsulting.ca?anonymous&ismsaljsauthenabled=true" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Button className="cta-primary">
                <Mail size={18} />
                Get in Touch
              </Button>
            </a>
            <a 
              href="https://www.linkedin.com/company/ido-adaptive/" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Button variant="outline" className="cta-secondary">
                <Linkedin size={18} />
                Connect on LinkedIn
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyToBuildSection;
